module.exports = __webpack_public_path__ + "static/media/five.80f8db63.svg";